import { render, staticRenderFns } from "./ManageWiki.vue?vue&type=template&id=fd01a8ca&scoped=true&"
import script from "./ManageWiki.vue?vue&type=script&lang=js&"
export * from "./ManageWiki.vue?vue&type=script&lang=js&"
import style0 from "./ManageWiki.vue?vue&type=style&index=0&id=fd01a8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01a8ca",
  null
  
)

export default component.exports